import { render, staticRenderFns } from "./carCreateFeeAdd.vue?vue&type=template&id=546ab6a8&scoped=true"
import script from "./carCreateFeeAdd.vue?vue&type=script&lang=js"
export * from "./carCreateFeeAdd.vue?vue&type=script&lang=js"
import style0 from "./carCreateFeeAdd.vue?vue&type=style&index=0&id=546ab6a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546ab6a8",
  null
  
)

export default component.exports